import { cache } from "../utils/cache";
import { time } from "../utils/time";

const LOCATION_CACHE_MS = time.minutesToMilliseconds(2);
const IP_LOCATION_API_URL = "https://ip.inference.net";

export type IPLocationResponse = {
  ip: string;
  location: {
    country: string;
    city: string;
    continent: string;
    latitude: number;
    longitude: number;
    postalCode: string;
    metroCode: string;
    region: string;
    regionCode: string;
    timezone: string;
  };
};

const getIPAndLocation = async (): Promise<IPLocationResponse> => {
  const response = await fetch(IP_LOCATION_API_URL);
  return await response.json();
};

export const cachedGetIPAndLocation = cache.memoize(
  "ipAndLocation",
  getIPAndLocation,
  LOCATION_CACHE_MS,
);
